import { createAsyncThunk } from "@reduxjs/toolkit";
import { authService } from "../../services/firebase/auth.service";
import { AuthUser } from "@/types/auth.types";
import { User } from "@/types/user.types";
import { auth } from "@/services/firebase/config";
import { onAuthStateChanged } from "firebase/auth";

export const loginUser = createAsyncThunk<AuthUser, { email: string; password: string }>(
  "auth/loginUser",
  async ({ email, password }, { rejectWithValue }) => {
    try {
      const user = await authService.login(email, password) as unknown as AuthUser;
      return user;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const registerUser = createAsyncThunk<AuthUser, { email: string; password: string; userData: Omit<User, 'documentId' | 'createdAt' | 'email'>}>(
  "auth/registerUser",
  async ({ email, password, userData }, { rejectWithValue }) => {
    try {
      const user = await authService.register({email, password, userData}) as unknown as AuthUser;
      return user;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const logoutUser = createAsyncThunk("auth/logoutUser", async () => {
  await authService.logout();
});

export const resetPassword = createAsyncThunk<void, string>(
  "auth/resetPassword",
  async (email, { rejectWithValue }) => {
    try {
      await authService.resetPassword(email);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const signInWithGoogle = createAsyncThunk<AuthUser>(
  "auth/signInWithGoogle",
  async (_, { rejectWithValue }) => {
    try {
      const user = await authService.signInWithGoogle() as unknown as AuthUser;
      return user;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const signInAttendantWithGoogle = createAsyncThunk<AuthUser>(
  "auth/signInAttendantWithGoogle",
  async (_, { rejectWithValue }) => {
    try {
      const user = await authService.signInAttendantWithGoogle() as unknown as AuthUser;
      return user;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const registerWithGoogle = createAsyncThunk<AuthUser, { userData: Omit<User, 'documentId' | 'email' | 'createdAt' | 'displayName'> }>(
  "auth/registerWithGoogle",
  async ({ userData }, { rejectWithValue }) => {
    try {
      const user = await authService.registerWithGoogle(userData) as unknown as AuthUser;
      return user;
    } catch (error: any) {
       
      return rejectWithValue(error.message);
    }
  }
);

export const initializeAuth = createAsyncThunk<AuthUser | null>(
  "auth/initializeAuth",
  async (_, { rejectWithValue }) => {
    try {
      return new Promise<AuthUser | null>((resolve) => {
        const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
          unsubscribe();
          if (firebaseUser) {
            // User is signed in, get the token with claims
            const tokenResult = await firebaseUser.getIdTokenResult(true);
            const authUser = {
              ...firebaseUser,
              role: tokenResult.claims.role as string
            } as unknown as AuthUser;
            resolve(authUser);
          } else {
            // No user is signed in
            resolve(null);
          }
        });
      });
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
